import React from "react";
import { Badge } from "react-bootstrap";

export const getEndpointUrl = () => {
  return process.env.REACT_APP_API_URL;
  //return "http://localhost/car-inspector-api";
};

export const getTimestamp = () => {
  const currentDate = new Date();

  return currentDate.getTime();
};

export const customStylesTable = {
  rows: {
    style: {
      minHeight: "35px", // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: "0px", // override the cell padding for head cells
      paddingRight: "0px",
    },
  },
  cells: {
    style: {
      paddingTop: "8px", // override the cell padding for data cells
      paddingBottom: "8px",
    },
  },
};

export const BootyCheckbox = React.forwardRef(({ onClick, ...rest }, ref) => (
  <div className="form-check">
    <input
      htmlFor="booty-check"
      type="checkbox"
      className="form-check-input"
      ref={ref}
      onClick={onClick}
      {...rest}
    />
    <label className="form-check-label" id="booty-check" />
  </div>
));

export const BadgeStatus = ({ status }) => {
  const colorStatus = () => {
    switch (status) {
      case "pending":
        return "warning";
      case "draft":
      case "sedang dikerjakan":
        return "info";
      case "complete":
      case "selesai":
      case "terkirim":
      case "dikerjakan":
      case "active":
      case "lunas":
        return "success";
      case "deactive":
      case "inspector":
      case "cancel":
        return "danger";
      case "admin":
        return "primary";
      default:
        return "secondary";
    }

    return "secondary";
  };

  return (
    <Badge bg={colorStatus()} className="fs-12 text-uppercase">
      {" "}
      {status}{" "}
    </Badge>
  );
};

// Javascript program to convert Roman
export const numberToRomawi = (nomor) => {
  let desimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
  let romawi = [
    "M",
    "CM",
    "D",
    "CD",
    "C",
    "XC",
    "L",
    "XL",
    "X",
    "IX",
    "V",
    "IV",
    "I",
  ];

  let hasil = "";

  for (let index = 0; index < desimal.length; index++) {
    while (desimal[index] <= nomor) {
      hasil += romawi[index];
      nomor -= desimal[index];
    }
  }
  return hasil;
};

export const terbilang = (angka) => {
  var bilne = [
    "",
    "satu",
    "dua",
    "tiga",
    "empat",
    "lima",
    "enam",
    "tujuh",
    "delapan",
    "sembilan",
    "sepuluh",
    "sebelas",
  ];

  if (angka < 12) {
    return bilne[angka];
  } else if (angka < 20) {
    return terbilang(angka - 10) + " belas";
  } else if (angka < 100) {
    return (
      terbilang(Math.floor(parseInt(angka) / 10)) +
      " puluh " +
      terbilang(parseInt(angka) % 10)
    );
  } else if (angka < 200) {
    return "seratus " + terbilang(parseInt(angka) - 100);
  } else if (angka < 1000) {
    return (
      terbilang(Math.floor(parseInt(angka) / 100)) +
      " ratus " +
      terbilang(parseInt(angka) % 100)
    );
  } else if (angka < 2000) {
    return "seribu " + terbilang(parseInt(angka) - 1000);
  } else if (angka < 1000000) {
    return (
      terbilang(Math.floor(parseInt(angka) / 1000)) +
      " ribu " +
      terbilang(parseInt(angka) % 1000)
    );
  } else if (angka < 1000000000) {
    return (
      terbilang(Math.floor(parseInt(angka) / 1000000)) +
      " juta " +
      terbilang(parseInt(angka) % 1000000)
    );
  } else if (angka < 1000000000000) {
    return (
      terbilang(Math.floor(parseInt(angka) / 1000000000)) +
      " milyar " +
      terbilang(parseInt(angka) % 1000000000)
    );
  } else if (angka < 1000000000000000) {
    return (
      terbilang(Math.floor(parseInt(angka) / 1000000000000)) +
      " trilyun " +
      terbilang(parseInt(angka) % 1000000000000)
    );
  }
};

export const CAR_MODEL_TYPES = [
  "SUV",
  "MINIBUS",
  "JEEP S.C.HDTP",
  "JEEP L.C.HDTP",
  "JEEP",
  "SEDAN",
  "MICRO/MINIBUS",
  "MINIVAN",
  "MPV"
];
